import ReactDOM from "react-dom";
import { useFetch } from "../hooks/useFetch"
import AdminForm from "./adminForm";
import UserNotFound from "../responses/userNotFound";
import { baseUrl } from "../common/consts/baseUrl";
import Loading  from "../Loading";

export default function UserLister({displayRef, query, em, token}){

    let temp = {};

    const url = "api/user/byEmail/" +
        query;

    const res = useFetch(url, token);

    while(res.response === null){
        //return(<h1>Loading...</h1>)
        return(<Loading />)
    }

    const useList = {
        users:[]
    }

    if(res.response.success === false){
        temp = {"userEmail" : query}
        try {    
            ReactDOM.render(<UserNotFound temp={temp} token={token} em={em} />,
                displayRef.current); 
        } catch(err){
            alert(err)
        }
    } else {
        useList.users.push(res.response)
    }

    const composeResult = (results, i) =>{
        temp = {
                    "userId"            : results.users[i]?.user?.userId,
                    "firstName"         : results.users[i]?.user.userDetails.userName.firstName,
                    "middleName"        : results.users[i]?.user.userDetails.userName.middleName,
                    "lastName"          : results.users[i]?.user.userDetails.userName.lastName,
                    "siBadgeNum"        : results.users[i]?.user.userDetails.siBadgeNum,
                    "jobCategoryId"     : results.users[i]?.user.userDetails.jobCategoryId,
                    "organization"      : results.users[i]?.user.userDetails.organization,
                    "officeTypeId"      : results.users[i]?.user.userDetails.officeTypeId,
                    "securityQuestion"  : results.users[i]?.user.userDetails.securityQuestion,
                    "securityAnswer"    : results.users[i]?.user.userDetails.securityAnswer,
                    "orgCoordinator"    : results.users[i]?.user.userDetails.orgCoordinator,
                    "orgCoordEmail"     : results.users[i]?.user.userDetails.orgCoordEmail,
                    "state"             : results.users[i]?.user.userDetails.state,
                    "category"          : results.users[i]?.user.userDetails.category,
                    "userEmail"         : query,
                    "prCountry"         : results.users[i]?.user.userDetails.searchPreference.country,
                    "prState"           : results.users[i]?.user.userDetails.searchPreference.state,
                    "prQuery"           : results.users[i]?.user.userDetails.searchPreference.query,
                    "hascdlisUser"      : false,
                    "hascdlisAdmin"     : false,
                    "hasMinimalDrivReq" : false,
                    "hasFcwd"           : false,
                    "hasFcwdTechSupp"   : false,
                    "hasTechSupp"       : false,
                    "hasMxSearch"       : false,
                    "hasCnSearch"       : false,
                    "hasCnFcwd"         : false,
                    "hasBatch"          : false,
                    "hasHelpDesk"       : false,
                    "hasCdlisFcwdOnly"  : false,
                    "isActive"          : results.users[i]?.user.userDetails.active,
                    "adminEmail"        : em,
                    //"active"            : results.users[i]?.user.userDetails.active,
                    "created"           : results.users[i]?.user.userDetails.created,
                    "updated"           : results.users[i]?.user.userDetails.updated,
                    "disabled"          : results.users[i]?.user.userDetails.disabled,
                    "lastAccessed"      : results.users[i]?.user.userDetails.lastAccessed
        }
        
        if(results.users[i].user.userDetails.roles.includes("cdlisUsr")){
              temp.hascdlisUser = true;
        }
        
        if(results.users[i].user.userDetails.roles.includes("cdlisAdmin")){
            temp.hascdlisAdmin = true;
        }

        if(results.users[i].user.userDetails.roles.includes("minimalDrivReq")){
            temp.hasMinimalDrivReq = true;
        }

        if(results.users[i].user.userDetails.roles.includes("fcwdState")){
            temp.hasFcwd = true;
        }

        if(results.users[i].user.userDetails.roles.includes("fcwdTechSupp")){
            temp.hasFcwdTechSupp = true;
        }

        if(results.users[i].user.userDetails.roles.includes("techSupp")){
            temp.hasTechSupp = true;
        }
        if(results.users[i].user.userDetails.roles.includes("searchMx")){
            temp.hasMxSearch = true;
        }
        if(results.users[i].user.userDetails.roles.includes("searchCn")){
            temp.hasCnSearch = true;
        }
        if(results.users[i].user.userDetails.roles.includes("cdlisFcwdOnly")){
            temp.hasCdlisFcwdOnly = true;
        }
        if(results.users[i].user.userDetails.roles.includes("batch")){
            temp.hasBatch = true;
        }
        if(results.users[i].user.userDetails.roles.includes("fcwdHelpDesk")){
            temp.hasHelpDesk = true;
        }
        if(results.users[i].user.userDetails.roles.includes("hasReports")){
            temp.hasHelpDesk = true;
        }

        const old = results.users[i].user;

        console.log("Old1: "+ JSON.stringify(old))

        try {    
            ReactDOM.render(<AdminForm temp={temp} old={old} em={em} 
            token={token} />,
                displayRef.current); 
        } catch(err){
            alert(err)
        }
        
    }

    if(useList.users.length === 1){
        console.log("O: "+JSON.stringify(useList.users))
        composeResult(useList,0)
    }

    const hadnelSelect = (results, i) => {
        composeResult(results, i);
    } 

    return(
        <div className="App" id="table"> 
            <table class="table table-striped table-bordered">
            <thead class="table-header">
                <tr>
                    <th scope="col">email</th>
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                    <th scope="col">Middle</th>
                    <th scope="col">Job Category</th>
                    <th scope="col">Organization</th>
                    <th scope="col">Office Type</th>
                </tr>
            </thead>
            <tbody>{useList.users.map((v,i) => (    
                <tr>
                    <td>           
                        <div>
                        <button
                            className="btn btn-outline"
                            onClick={(e) => hadnelSelect(useList, i)}>
                                {v.user.userDetails.userEmail}
                        </button>
                        </div>
                    </td>  
                    <td>{v.user.userDetails.userName.firstName}</td>
                    <td>{v.user.userDetails.userName.lastName}</td>
                    <td>{v.user.userDetails.userName.middleName}</td>
                    <td>{v.user.userDetails.jobCategoryId}</td>
                    <td>{v.user.userDetails.organization}</td>
                    <td>{v.user.userDetails.officeTypeId}</td>
                </tr>))}
            </tbody>
            <tr></tr>
            </table>
       </div>
    )      
}
